import { render, staticRenderFns } from "./IconSvgOds.vue?vue&type=template&id=38725bf9&scoped=true&"
import script from "./IconSvgOds.vue?vue&type=script&lang=js&"
export * from "./IconSvgOds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38725bf9",
  null
  
)

export default component.exports